// ==========================================================================
// Assume the provided EventBus class exists (do not modify it)
// It exposes methods with the following signature:
//    on(options: { eventName: string; handler: (payload: any) => void }): { off: () => void }
//    emit(options: { eventName: string; data?: any }): void
// ==========================================================================

// =============================================================================
// Abstract Transition class: Defines how a step transitions to other steps.
// Concrete implementations must define the transition logic in `onExecute`.
// =============================================================================

export type GetCtx = <T>(key: string, stepName?: string) => T | undefined;
export type SetCtx = <T>(key: string, value: T, stepName?: string) => void;

export abstract class Transition {
  public readonly entryStep: string;
  public readonly exitSteps: string[];

  public getCtx: GetCtx = <T>(_key: string, _stepName?: string): T | undefined => undefined;
  public setCtx: SetCtx = <T>(_key: string, _value: T, _stepName?: string): void => {};

  constructor(entryStep: string, exitSteps: string[]) {
    this.entryStep = entryStep;
    this.exitSteps = exitSteps;
  }

  abstract onExecute(): string[];
}